import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as dimensionFilter from '../../../../dimension-filter'
import * as clusters from '../../../clusters'
import type { TypeParams } from '../../types'

import * as effects from './effects'

/** Cluster dimension-filter plugin for the record-assignable-labs collection. */
export class Plugin extends dimensionFilter.currentList.Plugin<
  TypeParams,
  typeof Plugin.id
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static readonly id = ec.plugins.Plugin.Id.Custom.create(
    'ClusterDimensionFilter',
  )

  constructor({ collection }: Readonly<Plugin.constructor.Params>) {
    const clustersEc = ngCore.inject(clusters.Collection)

    super({
      collection,
      currentListFilterKey: 'clusterFilter',
      dimensionId: ents.core.dms.models.Dimension.Id.from(
        ents.extra.quiver.resources.data.dimensions.spaceClusters.RESOURCE
          .payload,
      ),
      id: Plugin.id,
    })

    this.feature.registerEffects(
      effects.reloadOptionsOnClusterChange(clustersEc),
    )
  }
}

export namespace Plugin {
  export namespace constructor {
    export interface Params {
      readonly collection: ec.Collection<TypeParams>
    }
  }
}
